(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AA-guide-theme-1"]) return;
  try {
    
(function () {
  function runDemo(btn, result) {
    if (!window.ButtonFeedback) return;
    btn.style.minWidth = btn.offsetWidth + 'px';
    window.ButtonFeedback.loading(btn);
    setTimeout(function () {
      if (result === 'error') {
        window.ButtonFeedback.error(btn);
      } else {
        window.ButtonFeedback.success(btn);
      }
    }, 1500);
  }

  document.querySelectorAll('[data-guide-demo-success]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-guide-demo-error]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'error'); });
  });

  document.querySelectorAll('[data-guide-demo-custom]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-guide-theme-2"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var content = document.querySelector('[data-article-content]');
    if (!content) return;

    function getVideoEmbedUrl(value) {
      if (!value) return null;

      try {
        var url = new URL(value, window.location.origin);
        var hostname = url.hostname.replace(/^www\./, '').toLowerCase();
        var pathParts = url.pathname.split('/').filter(Boolean);
        var videoId = '';

        if (hostname === 'youtube.com' || hostname === 'm.youtube.com' || hostname === 'youtube-nocookie.com') {
          if (url.pathname === '/watch' || url.pathname === '/watch/') {
            videoId = url.searchParams.get('v') || '';
          } else if (url.pathname === '/playlist' || url.pathname === '/playlist/') {
            var playlistId = url.searchParams.get('list') || '';
            if (playlistId) {
              return 'https://www.youtube-nocookie.com/embed/videoseries?list=' + encodeURIComponent(playlistId);
            }
          } else if (pathParts[0] === 'shorts' || pathParts[0] === 'embed') {
            videoId = pathParts[1] || '';
          }

          if (videoId) {
            if (videoId === 'videoseries') {
              var embeddedPlaylistId = url.searchParams.get('list') || '';
              if (embeddedPlaylistId) {
                return 'https://www.youtube-nocookie.com/embed/videoseries?list=' + encodeURIComponent(embeddedPlaylistId);
              }
            }

            return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId);
          }
        }

        if (hostname === 'youtu.be' && pathParts[0]) {
          return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(pathParts[0]);
        }

        if (hostname === 'vimeo.com' && pathParts[0] && /^\d+$/.test(pathParts[0])) {
          return 'https://player.vimeo.com/video/' + pathParts[0] + '?dnt=1';
        }

        if (hostname === 'player.vimeo.com') {
          url.searchParams.set('dnt', '1');
          return url.href;
        }
      } catch (error) {
        return null;
      }

      return null;
    }

    function configureIframe(iframe, sourceUrl) {
      var embedUrl = getVideoEmbedUrl(sourceUrl || iframe.getAttribute('src'));
      if (!embedUrl) return false;

      if (iframe.getAttribute('src') !== embedUrl) {
        iframe.setAttribute('src', embedUrl);
      }

      iframe.removeAttribute('width');
      iframe.removeAttribute('height');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('title', iframe.getAttribute('title') || 'Vídeo da postagem');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      return true;
    }

    function createVideoIframe(sourceUrl) {
      var embedUrl = getVideoEmbedUrl(sourceUrl);
      if (!embedUrl) return null;

      var iframe = document.createElement('iframe');
      iframe.className = 'article__embeddedVideo';
      iframe.src = embedUrl;
      configureIframe(iframe, embedUrl);
      return iframe;
    }

    var videoIframes = [];

    function refreshVideoIframes() {
      content.querySelectorAll('iframe').forEach(function (iframe) {
        if (configureIframe(iframe)) {
          iframe.setAttribute('data-article-video', 'true');
          if (videoIframes.indexOf(iframe) === -1) videoIframes.push(iframe);
        }
      });
    }

    refreshVideoIframes();

    function getInlineYoutubeRoot(player) {
      var current = player;

      while (current && current !== content) {
        var nextSibling = current.nextSibling;

        while (nextSibling && nextSibling.nodeType === 3 && !nextSibling.textContent.trim()) {
          nextSibling = nextSibling.nextSibling;
        }

        if (nextSibling && nextSibling.nodeType === 8 && nextSibling.data.toLowerCase().indexOf('end-inlined-iframe') !== -1) {
          return current;
        }

        current = current.parentElement;
      }

      current = player;
      while (current.parentElement && current.parentElement !== content) {
        current = current.parentElement;
      }

      return current;
    }

    function getVideoSourceUrl(root) {
      var sourceLink = root.querySelector('a[href*="youtube.com"], a[href*="youtu.be"]');
      if (sourceLink) return sourceLink.href;

      var sourceElement = root.querySelector('[data-video-id], [data-video-url], [data-src]');
      if (sourceElement) {
        var videoId = sourceElement.getAttribute('data-video-id');
        var videoUrl = sourceElement.getAttribute('data-video-url') || sourceElement.getAttribute('data-src');
        if (videoId) return 'https://www.youtube.com/watch?v=' + videoId;
        if (videoUrl && getVideoEmbedUrl(videoUrl)) return videoUrl;
      }

      var youtubeLinks = Array.from(content.querySelectorAll('a[href]')).filter(function (link) {
        return getVideoEmbedUrl(link.href);
      });

      return youtubeLinks.length === 1 ? youtubeLinks[0].href : '';
    }

    function removeInlineYoutubePlayers() {
      refreshVideoIframes();

      content.querySelectorAll('#player').forEach(function (player) {
        var inlineRoot = getInlineYoutubeRoot(player);
        if (!inlineRoot || inlineRoot === content || inlineRoot.querySelector('iframe')) return;

        var sourceUrl = getVideoSourceUrl(inlineRoot);
        var matchingIframe = videoIframes.find(function (iframe) {
          return isSameVideo(sourceUrl, iframe.getAttribute('src'));
        });

        if (matchingIframe || (!sourceUrl && videoIframes.length)) {
          inlineRoot.remove();
          return;
        }

        var replacementIframe = createVideoIframe(sourceUrl);
        if (replacementIframe) {
          replacementIframe.setAttribute('data-article-video', 'true');
          inlineRoot.replaceWith(replacementIframe);
          videoIframes.push(replacementIframe);
        }
      });
    }

    removeInlineYoutubePlayers();

    var inlineYoutubeObserver = new MutationObserver(function () {
      removeInlineYoutubePlayers();
    });
    inlineYoutubeObserver.observe(content, { childList: true, subtree: true });
    window.setTimeout(function () {
      inlineYoutubeObserver.disconnect();
    }, 10000);

    function getPreviewRoot(image) {
      var current = image.parentElement;

      while (current && current !== content) {
        var text = (current.textContent || '').toLowerCase();
        var hasYoutubeLink = current.querySelector('a[href*="youtube.com"], a[href*="youtu.be"]');
        var hasSubscriberText = text.indexOf('inscritos') !== -1 || text.indexOf('subscribers') !== -1;

        if (hasSubscriberText || (hasYoutubeLink && current.parentElement === content)) {
          return current;
        }

        current = current.parentElement;
      }

      return image.parentElement;
    }

    function isSameVideo(firstUrl, secondUrl) {
      var firstEmbedUrl = getVideoEmbedUrl(firstUrl);
      var secondEmbedUrl = getVideoEmbedUrl(secondUrl);
      return firstEmbedUrl && secondEmbedUrl && firstEmbedUrl === secondEmbedUrl;
    }

    content.querySelectorAll('img[alt]').forEach(function (thumbnail) {
      if ((thumbnail.getAttribute('alt') || '').toLowerCase() !== 'thumbnail-image') return;

      var previewRoot = getPreviewRoot(thumbnail);
      if (!previewRoot || previewRoot === content || previewRoot.querySelector('iframe')) return;

      var sourceLink = previewRoot.querySelector('a[href*="youtube.com"], a[href*="youtu.be"]');
      var sourceUrl = sourceLink ? sourceLink.href : '';
      var matchingIframe = videoIframes.find(function (iframe) {
        return isSameVideo(sourceUrl, iframe.getAttribute('src'));
      });

      if (matchingIframe || !sourceUrl) {
        if (matchingIframe || videoIframes.length) previewRoot.remove();
        return;
      }

      var replacementIframe = createVideoIframe(sourceUrl);
      if (replacementIframe) {
        replacementIframe.setAttribute('data-article-video', 'true');
        previewRoot.replaceWith(replacementIframe);
        videoIframes.push(replacementIframe);
      }
    });

    content.querySelectorAll('a[href]').forEach(function (link) {
      var parent = link.parentElement;
      if (!parent || parent === content || parent.children.length !== 1) return;
      if (parent.textContent.trim() !== link.textContent.trim()) return;

      var iframe = createVideoIframe(link.href);
      if (!iframe) return;

      parent.replaceWith(iframe);
      iframe.setAttribute('data-article-video', 'true');
      videoIframes.push(iframe);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-quantity-decrease], [data-cart-quantity-increase]');
    if (!button) return;

    var control = button.closest('.cart__quantityControl');
    var input = control ? control.querySelector('input[name="updates[]"]') : null;
    if (!input) return;

    var currentQuantity = parseInt(input.value, 10);
    if (isNaN(currentQuantity)) currentQuantity = 0;

    var change = button.hasAttribute('data-cart-quantity-increase') ? 1 : -1;
    input.value = Math.max(0, currentQuantity + change);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const collectionsPage = document.querySelector('[data-collections-page]');
    const header = document.querySelector('[data-header]');

    if (!collectionsPage || !header) return;

    const updateCollectionsOffset = () => {
      const headerBottom = header.getBoundingClientRect().bottom;
      collectionsPage.style.setProperty('--collections-header-offset', `${Math.max(0, headerBottom)}px`);
    };

    updateCollectionsOffset();
    window.addEventListener('resize', updateCollectionsOffset, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateCollectionsOffset).observe(header);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  (() => {
    const formatBrazilPhone = value => {
      const digits = value.replace(/\D/g, '').slice(0, 11);

      if (digits.length <= 2) return digits;
      if (digits.length <= 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}${digits.length > 6 ? `-${digits.slice(6, 10)}` : ''}`;
      }

      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
    };

    document.querySelectorAll('[data-brazil-phone]').forEach(input => {
      input.value = formatBrazilPhone(input.value);
      input.addEventListener('input', event => {
        event.target.value = formatBrazilPhone(event.target.value);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcementBar"]) return;
  try {
    
  (function () {
    function mountAnnouncementCarousel(element) {
      if (!element || element.dataset.splideMounted === 'true') return;
      if (typeof Splide === 'undefined') {
        window.setTimeout(function () { mountAnnouncementCarousel(element); }, 50);
        return;
      }

      element.dataset.splideMounted = 'true';

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var animation = element.dataset.announcementAnimation || 'slide';
      var autoplay = element.dataset.announcementAutoplay === 'true' && !reduceMotion;
      var interval = parseInt(element.dataset.announcementInterval || '5000', 10);
      var speed = reduceMotion ? 0 : parseInt(element.dataset.announcementSpeed || '600', 10);

      new Splide(element, {
        type: animation === 'fade' ? 'fade' : 'loop',
        rewind: animation === 'fade',
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: false,
        drag: false,
        autoplay: autoplay,
        interval: interval,
        speed: speed,
        pauseOnHover: true,
        pauseOnFocus: true,
      }).mount();
    }

    function initAnnouncementCarousels() {
      document.querySelectorAll('[data-announcement-carousel]').forEach(mountAnnouncementCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnouncementCarousels);
    } else {
      initAnnouncementCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadCatsSplide() {
      if (typeof window.Splide !== 'undefined') return Promise.resolve(window.Splide);
      if (typeof window.loadThemeSplide === 'function') return window.loadThemeSplide();
      if (window.ProductCarouselManager?.loadSplide) return window.ProductCarouselManager.loadSplide();
      return Promise.reject(new Error('Splide loader unavailable.'));
    }

    function mountCatsSplide(el) {
      if (!el || el.dataset.splideMounted || typeof Splide === 'undefined') return;
      el.dataset.splideMounted = '1';
      var categoryCount = Number(el.dataset.categoryCount || 0);
      var desktopStatic = categoryCount <= 5;
      new Splide(el, {
        type: desktopStatic ? 'slide' : 'loop',
        perPage: 5,
        perMove: 1,
        gap: '2px',
        trimSpace: false,
        arrows: false,
        pagination: !desktopStatic,
        drag: !desktopStatic,
        classes: {
          pagination: 'splide__pagination home-cats__pagination',
          page: 'splide__pagination__page',
        },
        breakpoints: {
          750: {
            type: 'loop',
            perPage: 2,
            perMove: 2,
            gap: '2px',
            padding: { left: '0px', right: '80px' },
            trimSpace: false,
            pagination: true,
            drag: true,
          },
        },
      }).mount();
    }
    document.addEventListener('DOMContentLoaded', function () {
      var carousels = Array.from(document.querySelectorAll('.home-cats__splide')).filter(function (el) {
        var categoryCount = Number(el.dataset.categoryCount || 0);
        return categoryCount > 5 || window.matchMedia('(max-width: 750px)').matches;
      });
      if (!carousels.length) return;

      var activate = function () {
        loadCatsSplide().then(function () {
          carousels.forEach(mountCatsSplide);
        }).catch(function () {});
      };
      if (document.readyState === 'complete') {
        if (window.requestIdleCallback) window.requestIdleCallback(activate, { timeout: 3000 });
        else window.setTimeout(activate, 1500);
      } else {
        window.addEventListener('load', activate, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyHeroArrowColor(el, slide) {
      const arrowColor = slide?.dataset.heroArrowColor;
      if (!arrowColor) return;

      el.style.setProperty('--hero-arrow-color', arrowColor);
      el.style.setProperty('--hero-pagination-border', arrowColor);
      el.style.setProperty('--hero-pagination-active', arrowColor);
      el.querySelectorAll('.splide__arrow').forEach(function (arrow) {
        arrow.style.setProperty('color', arrowColor, 'important');
        arrow.querySelectorAll('[stroke="currentColor"]').forEach(function (path) {
          path.style.setProperty('stroke', arrowColor, 'important');
        });
      });
      el.querySelectorAll('.splide__pagination__page').forEach(function (page) {
        page.style.setProperty('border-color', arrowColor, 'important');
        page.style.setProperty(
          'background-color',
          page.classList.contains('is-active') ? arrowColor : 'transparent',
          'important'
        );
      });
    }

    function syncActiveSlideStyles(el) {
      const activeSlide = el.querySelector('.splide__slide.is-active');
      if (!activeSlide) return;

      applyHeroArrowColor(el, activeSlide);
    }

    function getHeroMediaCache(el) {
      if (el.__heroMediaCache) return el.__heroMediaCache;

      const container = document.createElement('div');
      container.className = 'home-hero__media-cache';
      container.setAttribute('aria-hidden', 'true');
      el.appendChild(container);
      el.__heroMediaCache = { container: container, items: new Map() };
      return el.__heroMediaCache;
    }

    function getHeroMediaKey(container) {
      const slide = container.closest('.home-hero__slide');
      if (!slide) return null;

      const slideId = slide.dataset.heroSlideId;
      const isMobile = container.classList.contains('home-hero__media--mobile');
      return slideId + (isMobile ? ':mobile' : ':desktop');
    }

    function controlHeroMedia(media, action) {
      if (media.tagName === 'VIDEO') {
        if (action === 'pause') {
          media.pause();
        } else {
          media.play().catch(function () {});
        }
        return;
      }

      if (!media.contentWindow) return;

      const source = media.src || '';
      let message;
      if (source.indexOf('vimeo.com') !== -1) {
        message = { method: action };
      } else if (source.indexOf('youtube.com') !== -1 || source.indexOf('youtube-nocookie.com') !== -1) {
        message = { event: 'command', func: action === 'pause' ? 'pauseVideo' : 'playVideo', args: '' };
      }

      if (message) media.contentWindow.postMessage(JSON.stringify(message), '*');
    }

    function getActiveHeroSlide(el, splide) {
      const activeSlide = splide?.Components?.Slides?.getAt(splide.index)?.slide;
      if (activeSlide) return activeSlide;

      return el.querySelector('.splide__slide.is-visible') || el.querySelector('.splide__slide.is-active');
    }

    function markHeroMediaReady(item) {
      if (!item || item.ready) return;

      item.ready = true;
      item.container.classList.add('is-ready');
    }

    function bindHeroMediaReady(item) {
      const media = item.media;
      const onReady = function () {
        markHeroMediaReady(item);
      };

      if (media.tagName === 'VIDEO') {
        media.addEventListener('loadeddata', onReady, { once: true });
        media.addEventListener('canplay', onReady, { once: true });
        media.addEventListener('ended', function () {
          if (!media.isConnected) return;

          media.currentTime = 0;
          media.play().catch(function () {});
        });
        if (media.readyState >= 2) onReady();
      } else {
        media.addEventListener('load', onReady, { once: true });
      }
    }

    function getHeroMediaItem(container, cache, onExternalMediaReady) {
      const key = getHeroMediaKey(container);
      if (!key) return null;

      const cachedItem = cache.items.get(key);
      if (cachedItem) return cachedItem;

      const template = container.querySelector('[data-hero-media-template]');
      if (!template) return null;

      // O poster já está visível; adia o iframe externo inicial para não
      // disputar CPU/rede com o LCP. A navegação continua carregando o vídeo
      // após a janela crítica, e o cache permite uso normal nos próximos slides.
      const externalMedia = template.content.querySelector('iframe');
      if (externalMedia && !cache.externalMediaAllowed) {
        if (!cache.externalMediaScheduled) {
          cache.externalMediaScheduled = true;
          window.setTimeout(function () {
            cache.externalMediaAllowed = true;
            cache.externalMediaScheduled = false;
            if (onExternalMediaReady) onExternalMediaReady();
          }, 60000);
        }
        return null;
      }

      const itemContainer = document.createElement('div');
      itemContainer.className = 'home-hero__media-cache-item';
      itemContainer.dataset.heroMediaKey = key;
      const mediaContent = template.content.cloneNode(true);
      const media = mediaContent.querySelector('video, iframe');
      if (!media) return null;

      itemContainer.appendChild(mediaContent);

      const item = { container: itemContainer, media: media, ready: false };
      cache.items.set(key, item);
      bindHeroMediaReady(item);
      cache.container.appendChild(itemContainer);
      return item;
    }

    function preloadNextHeroMedia(activeSlide, splide, isMobile, cache) {
      if (!splide || splide.length < 2) return;

      const nextIndex = (splide.index + 1) % splide.length;
      const nextSlide = splide.Components?.Slides?.getAt(nextIndex)?.slide;
      if (!nextSlide) return;

      const mediaClass = isMobile ? 'home-hero__media--mobile' : 'home-hero__media--desktop';
      const nextContainer = Array.from(nextSlide.querySelectorAll('.home-hero__media')).find(function (container) {
        return container.classList.contains(mediaClass);
      });
      const nextTemplate = nextContainer?.querySelector('[data-hero-media-template]');

      // Mantém o carregamento antecipado apenas para vídeos hospedados na Shopify.
      // Iframes externos continuam sendo carregados somente quando o slide fica ativo.
      if (!nextTemplate?.content?.querySelector('video')) return;

      const nextItem = getHeroMediaItem(nextContainer, cache);
      if (nextItem?.media?.tagName === 'VIDEO') {
        nextItem.media.pause();
      }
    }

    function scheduleNextHeroMediaPreload(activeSlide, splide, isMobile, cache) {
      const slideKey = activeSlide.dataset.heroSlideId + (isMobile ? ':mobile' : ':desktop');
      if (cache.preloadKey === slideKey) return;
      cache.preloadKey = slideKey;

      const preload = function () {
        preloadNextHeroMedia(activeSlide, splide, isMobile, cache);
      };

      if (window.requestIdleCallback) {
        window.requestIdleCallback(preload, { timeout: 1200 });
      } else {
        window.setTimeout(preload, 250);
      }
    }

    function setHeroMediaActive(item, active) {
      if (!item) return;

      item.container.classList.toggle('is-active', active);
      controlHeroMedia(item.media, active ? 'play' : 'pause');
    }

    function syncHeroMedia(el, splide) {
      const activeSlide = getActiveHeroSlide(el, splide);
      if (!activeSlide) return;

      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      const cache = getHeroMediaCache(el);
      const activeContainer = Array.from(activeSlide.querySelectorAll('.home-hero__media')).find(function (container) {
        return container.classList.contains(isMobile ? 'home-hero__media--mobile' : 'home-hero__media--desktop');
      });
      const activeItem = activeContainer ? getHeroMediaItem(activeContainer, cache, function () {
        syncHeroMedia(el, splide);
      }) : null;

      cache.items.forEach(function (item) {
        setHeroMediaActive(item, item === activeItem);
      });

      scheduleNextHeroMediaPreload(activeSlide, splide, isMobile, cache);
    }

    function mountHeroSplide(el) {
      if (!el) return;
      if (el.dataset.splideMounted) {
        syncActiveSlideStyles(el);
        syncHeroMedia(el, el.__heroSplide);
        return;
      }
      if (typeof Splide === 'undefined') return;
      el.dataset.splideMounted = '1';
      const autoplayEnabled = el.dataset.heroAutoplay === 'true';
      const showArrows = el.dataset.heroShowArrows === 'true';
      const showPagination = el.dataset.heroShowPagination === 'true';
      const pauseOnHover = el.dataset.heroPauseOnHover === 'true';
      const pauseOnFocus = el.dataset.heroPauseOnFocus === 'true';
      const pauseOnDrag = el.dataset.heroPauseOnDrag === 'true';
      const autoplayInterval = parseInt(el.dataset.heroAutoplayInterval || '5000', 10);
      const splide = new Splide(el, {
        // type: 'loop',
        perPage: 1,
        autoplay: autoplayEnabled,
        interval: autoplayInterval,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: pauseOnFocus,
        resetProgress: false,
        arrows: showArrows,
        pagination: showPagination,
        paginationEl: el.querySelector('.home-hero__pagination'),
        classes: {
          arrows: 'splide__arrows home-hero__arrows',
          arrow: 'splide__arrow home-hero__arrow',
          prev: 'splide__arrow--prev',
          next: 'splide__arrow--next',
          pagination: 'splide__pagination home-hero__pagination',
          page: 'splide__pagination__page',
        },
      });

      splide.on('mounted moved', function () {
        syncHeroMedia(el, splide);
        window.requestAnimationFrame(function () {
          syncActiveSlideStyles(el);
        });
      });

      splide.on('active', function (slide) {
        applyHeroArrowColor(el, slide.slide);
        syncHeroMedia(el, splide);
      });

      splide.mount();
      el.__heroSplide = splide;
      syncHeroMedia(el, splide);

      const allowExternalMediaOnInteraction = function () {
        const cache = getHeroMediaCache(el);
        cache.externalMediaAllowed = true;
        cache.externalMediaScheduled = false;
        syncHeroMedia(el, splide);
      };
      el.addEventListener('pointerdown', allowExternalMediaOnInteraction, { once: true, passive: true });
      el.addEventListener('keydown', allowExternalMediaOnInteraction, { once: true });

      const viewportQuery = window.matchMedia('(max-width: 1023px)');
      const syncHeroMediaOnViewportChange = function () {
        syncHeroMedia(el, splide);
      };
      if (viewportQuery.addEventListener) {
        viewportQuery.addEventListener('change', syncHeroMediaOnViewportChange);
      } else if (viewportQuery.addListener) {
        viewportQuery.addListener(syncHeroMediaOnViewportChange);
      }

      if (autoplayEnabled) {
        const autoplay = splide.Components.Autoplay;
        let pointerInside = false;
        let hasFocus = false;
        const pauseAutoplay = function () {
          autoplay?.pause();
        };
        const resumeAutoplay = function () {
          if ((pauseOnHover && pointerInside) || (pauseOnFocus && hasFocus)) return;
          autoplay?.play();
        };

        if (pauseOnHover) {
          el.addEventListener('mouseenter', function () {
            pointerInside = true;
          });
          el.addEventListener('mouseleave', function () {
            pointerInside = false;
            resumeAutoplay();
          });
        }

        if (pauseOnFocus) {
          el.addEventListener('focusin', function () {
            hasFocus = true;
          });
          el.addEventListener('focusout', function () {
            window.requestAnimationFrame(function () {
              hasFocus = el.contains(document.activeElement);
              resumeAutoplay();
            });
          });
        }

        if (pauseOnDrag) {
          splide.on('drag', pauseAutoplay);
          splide.on('dragged', resumeAutoplay);
          el.addEventListener('touchstart', pauseAutoplay, { passive: true });
          el.addEventListener('touchend', resumeAutoplay, { passive: true });
          el.addEventListener('touchcancel', resumeAutoplay, { passive: true });
        }
      }
    }

    function loadHeroSplide() {
      if (typeof window.Splide !== 'undefined') return Promise.resolve(window.Splide);
      if (typeof window.loadThemeSplide === 'function') return window.loadThemeSplide();
      if (window.ProductCarouselManager?.loadSplide) return window.ProductCarouselManager.loadSplide();
      return Promise.reject(new Error('Splide loader unavailable.'));
    }

    function getHeroSplide(target) {
      if (!(target instanceof Element)) return null;
      if (target.matches('.home-hero__splide')) return target;
      return target.closest('.home-hero__splide') || target.querySelector('.home-hero__splide');
    }

    function refreshHeroFromEditor(event) {
      const hero = getHeroSplide(event.target);
      if (!hero) return;
      loadHeroSplide().then(function () {
        mountHeroSplide(hero);
        syncActiveSlideStyles(hero);
        syncHeroMedia(hero, hero.__heroSplide);
      }).catch(function () {});
    }

    function refreshAllHeroSplides() {
      document.querySelectorAll('.home-hero__splide').forEach(function (hero) {
        mountHeroSplide(hero);
      });
    }

    function scheduleInitialHeroMount() {
      let scheduled = false;
      const start = function () {
        if (scheduled) return;
        scheduled = true;

        const load = function () {
          loadHeroSplide().then(refreshAllHeroSplides).catch(function () {});
        };
        if (window.requestIdleCallback) {
          window.requestIdleCallback(load, { timeout: 5000 });
        } else {
          window.setTimeout(load, 3000);
        }
      };

      if (document.readyState === 'complete') {
        start();
      } else {
        window.addEventListener('load', start, { once: true });
      }

      ['pointerdown', 'keydown', 'touchstart'].forEach(function (eventName) {
        document.addEventListener(eventName, start, { once: true, passive: eventName !== 'keydown' });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      scheduleInitialHeroMount();

      const editorObserver = new MutationObserver(function () {
        refreshAllHeroSplides();
      });
      editorObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-hero-arrow-color'],
        childList: true,
        subtree: true,
      });
    });
    document.addEventListener('shopify:section:load', refreshHeroFromEditor);
    document.addEventListener('shopify:section:select', refreshHeroFromEditor);
    document.addEventListener('shopify:block:select', refreshHeroFromEditor);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-kits-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadLazyIframe(iframe) {
      if (!iframe || iframe.hasAttribute('src') || !iframe.dataset.lazySrc) return;
      iframe.src = iframe.dataset.lazySrc;
      iframe.removeAttribute('data-lazy-src');
    }

    function initLazyIframes() {
      var iframes = document.querySelectorAll('iframe[data-lazy-src]');
      if (!iframes.length) return;

      if (!('IntersectionObserver' in window)) {
        iframes.forEach(loadLazyIframe);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadLazyIframe(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '700px 0px' });

      iframes.forEach(function (iframe) { observer.observe(iframe); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLazyIframes, { once: true });
    } else {
      initLazyIframes();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-kits-promo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadVideo = (video) => {
      if (!video || video.dataset.videoLoaded === 'true') return;

      const sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;

      if (video.dataset.poster) {
        video.poster = video.dataset.poster;
        video.removeAttribute('data-poster');
      }

      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.dataset.videoLoaded = 'true';
      video.load();
      const playback = video.play();
      if (playback?.catch) playback.catch(() => {});
    };

    const boot = () => {
      const videos = document.querySelectorAll('[data-lazy-video]');
      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) {
        videos.forEach(loadVideo);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px' });

      videos.forEach((video) => observer.observe(video));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-recomendados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mountRecomSplide(el) {
      if (!el || el.dataset.splideMounted || typeof Splide === 'undefined') return;
      el.dataset.splideMounted = '1';
      el.recomSplide = new Splide(el, {
        // type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: '16px',
        trimSpace: false,
        arrows: false,
        pagination: true,
        drag: true,
        breakpoints: {
          750: {
            perPage: 1,
            gap: '12px',
            padding: { left: '0px', right: '28%' },
            focus: 0,
            trimSpace: true
          }
        },
        paginationEl: el.querySelector('.home-recom__pagination'),
        classes: {
          pagination: 'splide__pagination home-recom__pagination',
          page: 'splide__pagination__page',
        },
      }).mount();
    }

    function getActiveVideo(slide) {
      var videos = slide.querySelectorAll('video');
      for (var i = 0; i < videos.length; i++) {
        if (videos[i].offsetParent !== null) return videos[i];
      }
      return null;
    }

    function initVideoControls(slide) {
      var controls = slide.querySelector('[data-recom-controls]');
      if (!controls || controls.dataset.controlsReady) return;
      controls.dataset.controlsReady = 'true';

      var playBtn = controls.querySelector('[data-play-btn]');
      var muteBtn = controls.querySelector('[data-mute-btn]');

      function updatePlayIcon(paused) {
        playBtn.querySelector('[data-icon-play]').classList.toggle('hidden', !paused);
        playBtn.querySelector('[data-icon-pause]').classList.toggle('hidden', paused);
      }

      function updateMuteIcon(muted) {
        muteBtn.querySelector('[data-icon-muted]').classList.toggle('hidden', !muted);
        muteBtn.querySelector('[data-icon-sound]').classList.toggle('hidden', muted);
      }

      playBtn.addEventListener('click', function () {
        var video = getActiveVideo(slide);
        if (!video) return;
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      muteBtn.addEventListener('click', function () {
        var video = getActiveVideo(slide);
        if (!video) return;
        var newMuted = !video.muted;
        slide.querySelectorAll('video').forEach(function (v) {
          v.muted = newMuted;
        });
        updateMuteIcon(newMuted);
      });

      slide.querySelectorAll('video').forEach(function (video) {
        video.addEventListener('play', function () { updatePlayIcon(false); });
        video.addEventListener('pause', function () { updatePlayIcon(true); });
      });
    }

    var observer;
    function activate(el) {
      if (!el.isConnected) return;
      var ready = typeof window.Splide !== 'undefined'
        ? Promise.resolve()
        : window.ProductCarouselManager?.loadSplide?.()
          || window.loadThemeSplide?.();
      Promise.resolve(ready).then(function () {
        if (!el.isConnected) return;
        mountRecomSplide(el);
        el.querySelectorAll('.splide__slide').forEach(initVideoControls);
      }).catch(function () {});
    }
    function init(scope) {
      scope.querySelectorAll('.home-recom__splide').forEach(function (el) {
        if (el.dataset.splideMounted) return;
        if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
          activate(el);
          return;
        }
        if (!observer) {
          observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              activate(entry.target);
            });
          }, { rootMargin: '300px 0px' });
        }
        observer.observe(el);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.home-recom__splide').forEach(function (el) {
        observer?.unobserve(el);
        el.recomSplide?.destroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pdp-section-id]').forEach(function (section) {
    const sid = section.dataset.pdpSectionId;

    const variantDataEl = document.getElementById('pdp-variants-' + sid);
    if (!variantDataEl) return;
    const productData = JSON.parse(variantDataEl.textContent);
    const variantImageDataEl = document.getElementById('pdp-variant-images-' + sid);
    const variantImageData = variantImageDataEl
      ? JSON.parse(variantImageDataEl.textContent)
      : [];

    const variantInput = section.querySelector('[data-variant-id]');
    const priceEl      = section.querySelector('[data-variant-price]');
    const comparePriceEl = section.querySelector('[data-compare-price]');
    const discountBadgeEl = section.querySelector('[data-discount-badge]');
    const productTagEls = section.querySelectorAll('[data-product-tag]');
    const skuEl        = section.querySelector('[data-variant-sku]');
    const skuSeparatorEl = section.querySelector('[data-variant-sku-separator]');
    const installmentEl = section.querySelector('[data-installment-text]');
    const buyBtn       = section.querySelector('[data-add-to-cart]');
    const buyBar       = section.querySelector('[data-buy-bar]');
    const buyBarSentinel = section.querySelector('[data-buy-bar-sentinel]');
    const galleryImageMap = new Map(
      Array.prototype.map.call(variantImageData, function (image) {
        return [String(image.id), image];
      })
    );

    function activateExternalVideo(wrapper) {
      if (!wrapper || wrapper.dataset.videoActivated === 'true') return;

      const src = wrapper.dataset.pdpVideoSrc;
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = wrapper.dataset.pdpVideoTitle || '';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('allowfullscreen', '');

      wrapper.dataset.videoActivated = 'true';
      wrapper.classList.add('is-active');
      wrapper.appendChild(iframe);
    }

    section.querySelectorAll('[data-pdp-external-video]').forEach(function (wrapper) {
      const trigger = wrapper.querySelector('[data-pdp-video-trigger]');
      trigger?.addEventListener('click', function () {
        activateExternalVideo(wrapper);
      });
    });

    const autoplayVideo = Array.prototype.find.call(
      section.querySelectorAll('[data-pdp-video-autoplay]'),
      function (wrapper) {
        return wrapper.offsetParent !== null;
      }
    );

    if (autoplayVideo) {
      const startAutoplayVideo = function () {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(function () {
            activateExternalVideo(autoplayVideo);
          }, { timeout: 1200 });
        } else {
          window.setTimeout(function () {
            activateExternalVideo(autoplayVideo);
          }, 400);
        }
      };

      if (document.readyState === 'complete') {
        startAutoplayVideo();
      } else {
        window.addEventListener('load', startAutoplayVideo, { once: true });
      }
    }

    function getVariantImage(variant) {
      if (!variant) return null;

      var image = galleryImageMap.get(String(variant.id));
      if (image?.url) return image;

      var featuredImage = variant.featured_image || variant.image;
      if (!featuredImage) return null;

      var url = featuredImage.src || featuredImage.url;
      if (!url) return null;

      return {
        id: featuredImage.id,
        url: url.indexOf('//') === 0 ? 'https:' + url : url,
        alt: featuredImage.alt || ''
      };
    }

    function createVariantGallerySlide(container, image) {
      if (!container) return null;

      var slide = document.createElement('div');
      var isMobile = container.id.indexOf('pdp-mobile-gallery-') === 0;
      slide.className = isMobile ? 'w-full shrink-0 snap-start' : 'w-full';
      slide.dataset.pdpGallerySlide = '';
      slide.dataset.mediaId = image.id || '';
      slide.dataset.galleryVariant = 'true';

      var img = document.createElement('img');
      img.className = 'pdp__media--' + sid + ' w-full block object-cover';
      img.src = image.url;
      img.alt = image.alt || '';
      img.loading = 'eager';
      img.dataset.galleryImage = '';
      slide.appendChild(img);
      container.appendChild(slide);
      return slide;
    }

    function restoreInitialGallery() {
      section.querySelectorAll('[data-pdp-gallery-slide]').forEach(function (slide) {
        slide.style.display = slide.hasAttribute('data-gallery-initial') ? '' : 'none';
      });
    }

    function renderVariantGallery(variant) {
      var image = getVariantImage(variant);
      if (!image) {
        restoreInitialGallery();
        return;
      }

      var mobileGallery = section.querySelector('[id^="pdp-mobile-gallery-"]');
      var desktopGallery = mobileGallery?.parentElement?.nextElementSibling;
      var containers = [mobileGallery, desktopGallery].filter(Boolean);

      containers.forEach(function (container) {
        var slide = Array.prototype.find.call(
          container.querySelectorAll('[data-pdp-gallery-slide]'),
          function (candidate) {
            return String(candidate.dataset.mediaId) === String(image.media_id || image.id);
          }
        );

        if (!slide) slide = createVariantGallerySlide(container, image);

        container.querySelectorAll('[data-pdp-gallery-slide]').forEach(function (candidate) {
          candidate.style.display = candidate === slide ? '' : 'none';
        });
      });

      if (mobileGallery) mobileGallery.scrollLeft = 0;
    }

    var accessoryControls = section.querySelectorAll('[data-accessory-select]');
    var productForm = section.querySelector('form[data-product-form]');
    var accessorySyncPromise = null;
    var accessoryStateDirty = false;
    var accessoryStateRevision = 0;

    function getAccessorySource() {
      return {
        productId: productForm?.dataset.productId || '',
        productHandle: productForm?.dataset.productHandle || '',
      };
    }

    function getAccessoryLineType(item) {
      var properties = item?.properties || {};
      return properties._pdp_accessory_type
        || properties.pdp_accessory_type
        || 'accessory';
    }

    function isAccessoryLine(item) {
      var source = getAccessorySource();
      var properties = item?.properties || {};
      var isMarkedAccessory = Boolean(
        properties._pdp_accessory
        || properties.pdp_accessory
        || properties._pdp_bundle_role === 'accessory'
        || properties.pdp_bundle_role === 'accessory'
      );
      var itemProductId = String(
        properties._pdp_accessory_product_id
        || properties.pdp_accessory_product_id
        || properties._pdp_product_id
        || properties.pdp_product_id
        || ''
      );
      var itemProductHandle = String(
        properties._pdp_accessory_product_handle
        || properties.pdp_accessory_product_handle
        || properties._pdp_product_handle
        || properties.pdp_product_handle
        || ''
      );

      if (!isMarkedAccessory) return false;
      if (source.productId && itemProductId === String(source.productId)) return true;
      return Boolean(source.productHandle && itemProductHandle === source.productHandle);
    }

    function getSelectedAccessories() {
      return Array.prototype.map.call(
        section.querySelectorAll('[data-accessory-option][aria-selected="true"][data-available="true"]'),
        function (option) {
          return {
            variantId: option.dataset.variantId,
            type: option.closest('[data-accessory-select]')?.dataset.accessoryType || 'accessory',
          };
        }
      ).filter(function (accessory) {
        return accessory.variantId;
      });
    }

    function getAccessoryKey(accessory) {
      return `${accessory.type}:${accessory.variantId}`;
    }

    function getAccessoryProperties(accessory) {
      var source = getAccessorySource();
      return {
        _pdp_accessory: 'true',
        _pdp_accessory_type: accessory.type,
        _pdp_accessory_product_id: source.productId,
        _pdp_accessory_product_handle: source.productHandle,
      };
    }

    function getAccessoryOptionLabel(option) {
      var label = option.querySelector('[data-accessory-label]')?.textContent.trim()
        || option.textContent.trim();
      var productTitle = option.dataset.productTitle;

      if (productTitle && label && label !== productTitle && label !== 'Default Title') {
        return `${productTitle} - ${label}`;
      }

      return productTitle || label;
    }

    function closeAccessoryVariantLists(control, except) {
      control?.querySelectorAll('[data-accessory-variant-list]').forEach(function (variantList) {
        if (variantList === except) return;

        variantList.classList.add('hidden');
        variantList.parentElement?.querySelector('[data-accessory-product-trigger]')?.setAttribute('aria-expanded', 'false');
      });
    }

    function updateAccessoryProductStates(control) {
      var selectLabel = control.dataset.accessorySelectLabel || 'Selecione';

      control.querySelectorAll('[data-accessory-product]').forEach(function (product) {
        var selected = product.querySelector('[data-accessory-option][aria-selected="true"]');
        var trigger = product.querySelector('[data-accessory-product-trigger]');
        var value = product.querySelector('[data-accessory-product-value]');

        product.classList.toggle('font-medium', Boolean(selected));
        trigger?.classList.toggle('font-medium', Boolean(selected));
        if (value) {
          value.textContent = selected
            ? selected.querySelector('[data-accessory-label]')?.textContent.trim() || selectLabel
            : selectLabel;
        }
      });
    }

    function updateAccessoryControlDisplay(control) {
      var selected = control.querySelectorAll('[data-accessory-option][aria-selected="true"]');
      var display = control.querySelector('[data-accessory-display]');
      var selectLabel = control.dataset.accessorySelectLabel || 'Selecione';
      if (!display) return;

      display.textContent = selected.length
        ? Array.prototype.map.call(selected, function (item) {
          return getAccessoryOptionLabel(item);
        }).filter(Boolean).join(', ')
        : selectLabel;

      updateAccessoryProductStates(control);
    }

    function clearAccessorySelection(control) {
      control.querySelectorAll('[data-accessory-option]').forEach(function (option) {
        option.setAttribute('aria-selected', 'false');
        option.classList.remove('font-medium');
      });
      closeAccessoryVariantLists(control);
      updateAccessoryControlDisplay(control);
    }

    function selectNoAccessory(control) {
      clearAccessorySelection(control);
      var noAccessory = control.querySelector('[data-no-accessory="true"]');
      if (noAccessory) {
        noAccessory.setAttribute('aria-selected', 'true');
        noAccessory.classList.add('font-medium');
        updateAccessoryControlDisplay(control);
      }
    }

    function updateAccessoryControlsFromCart(cart) {
      var cartAccessoryKeys = new Set(
        (cart?.items || []).filter(isAccessoryLine).map(function (item) {
          return getAccessoryKey({
            type: getAccessoryLineType(item),
            variantId: item.variant_id,
          });
        })
      );

      accessoryControls.forEach(function (control) {
        var type = control.dataset.accessoryType || 'accessory';
        control.querySelectorAll('[data-accessory-option]').forEach(function (option) {
          var selected = cartAccessoryKeys.has(getAccessoryKey({
            type: type,
            variantId: option.dataset.variantId,
          }));
          option.setAttribute('aria-selected', String(selected));
          option.classList.toggle('font-medium', selected);
        });
        updateAccessoryControlDisplay(control);
      });

      updateUI(findVariant());
    }

    function syncAccessories(options) {
      options = options || {};
      if (accessorySyncPromise) {
        return accessorySyncPromise.then(function () {
          if (accessoryStateDirty) return syncAccessories(options);
        });
      }
      if (!accessoryStateDirty) return Promise.resolve();

      var syncRevision = accessoryStateRevision;
      accessoryStateDirty = false;

      accessorySyncPromise = (async function () {
        try {
          var selectedAccessories = getSelectedAccessories();
          var desiredAccessories = new Map();
          selectedAccessories.forEach(function (accessory) {
            desiredAccessories.set(getAccessoryKey(accessory), accessory);
          });

          var cartResult = await window.CartManager?.get();
          if (!cartResult?.success) {
            accessoryStateDirty = true;
            return;
          }

          var existingAccessories = (cartResult.data?.items || []).filter(isAccessoryLine);
          var keptKeys = new Set();
          var removeKeys = [];

          existingAccessories.forEach(function (item) {
            var key = getAccessoryKey({
              type: getAccessoryLineType(item),
              variantId: item.variant_id,
            });
            if (desiredAccessories.has(key) && !keptKeys.has(key)) {
              keptKeys.add(key);
            } else {
              removeKeys.push(item.key);
            }
          });

          var changed = false;
          var syncFailed = false;
          for (const key of removeKeys) {
            var removeResult = await window.CartManager?.remove(key, { action: 'accessory_sync' });
            if (removeResult?.success) changed = true;
            else syncFailed = true;
          }

          for (const accessory of desiredAccessories.values()) {
            var accessoryKey = getAccessoryKey(accessory);
            if (keptKeys.has(accessoryKey)) continue;

            var addResult = await window.CartManager?.add(accessory.variantId, {
              quantity: 1,
              action: 'accessory_sync',
              properties: getAccessoryProperties(accessory),
            });
            if (addResult?.success) changed = true;
            else syncFailed = true;
          }

          if (syncFailed) accessoryStateDirty = true;

          if (options.openDrawer !== false && changed) {
            await window.CartDrawerManager?.refresh();
            window.DrawerManager?.open('cart');
          }
        } catch (error) {
          accessoryStateDirty = true;
          console.error('[PDP accessories] Sync failed:', error);
        } finally {
          if (accessoryStateRevision !== syncRevision) accessoryStateDirty = true;
        }
      })().finally(function () {
        accessorySyncPromise = null;
      });

      return accessorySyncPromise;
    }

    window.pdpAccessorySync = syncAccessories;

    accessoryControls.forEach(function (control) {
      var trigger = control.querySelector('[data-accessory-trigger]');
      var list = control.querySelector('[data-accessory-list]');
      var icon = control.querySelector('[data-accessory-icon]');

      control.addEventListener('focusout', function (event) {
        var movedToAccessoryControl = event.relatedTarget
          && Array.prototype.some.call(accessoryControls, function (otherControl) {
            return otherControl.contains(event.relatedTarget);
          });
        if (!movedToAccessoryControl) syncAccessories();
      });

      trigger?.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = !list.classList.contains('hidden');
        list.classList.toggle('hidden', open);
        trigger.setAttribute('aria-expanded', String(!open));
        icon?.classList.toggle('rotate-180', !open);
      });

      control.querySelectorAll('[data-accessory-product-trigger]').forEach(function (productTrigger) {
        productTrigger.addEventListener('click', function (event) {
          event.stopPropagation();
          var product = productTrigger.closest('[data-accessory-product]');
          var variantList = product?.querySelector('[data-accessory-variant-list]');
          if (!variantList) return;

          var open = !variantList.classList.contains('hidden');
          closeAccessoryVariantLists(control, variantList);
          variantList.classList.toggle('hidden', open);
          productTrigger.setAttribute('aria-expanded', String(!open));
        });
      });

      control.querySelectorAll('[data-accessory-option]').forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.stopPropagation();
          if (option.dataset.available !== 'true') return;
          accessoryStateDirty = true;
          accessoryStateRevision += 1;

          if (option.dataset.noAccessory === 'true') {
            selectNoAccessory(control);
            updateUI(findVariant());
            syncAccessories({ openDrawer: false }).then(function () {
              return window.CartDrawerManager?.refresh();
            });
            return;
          }

          var product = option.closest('[data-accessory-product]');
          if (product) {
            product.querySelectorAll('[data-accessory-option]').forEach(function (productOption) {
              if (productOption === option) return;
              productOption.setAttribute('aria-selected', 'false');
              productOption.classList.remove('font-medium');
            });
            closeAccessoryVariantLists(control);
          }

          var noAccessory = control.querySelector('[data-no-accessory="true"]');
          if (noAccessory) {
            noAccessory.setAttribute('aria-selected', 'false');
            noAccessory.classList.remove('font-medium');
          }
          option.setAttribute('aria-selected', option.getAttribute('aria-selected') !== 'true' ? 'true' : 'false');
          option.classList.toggle('font-medium', option.getAttribute('aria-selected') === 'true');
          updateAccessoryControlDisplay(control);
          updateUI(findVariant());
          syncAccessories();
        });
      });

    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-accessory-select]')) return;
      accessoryControls.forEach(function (control) {
        var list = control.querySelector('[data-accessory-list]');
        var trigger = control.querySelector('[data-accessory-trigger]');
        var icon = control.querySelector('[data-accessory-icon]');
        list?.classList.add('hidden');
        trigger?.setAttribute('aria-expanded', 'false');
        icon?.classList.remove('rotate-180');
      });
    });

    document.addEventListener('cart:removed', function (event) {
      if (event.detail?.action === 'accessory_sync') return;
      accessoryStateDirty = false;
      accessoryStateRevision += 1;
      updateAccessoryControlsFromCart(event.detail?.data);
    });

    document.addEventListener('cart:cleared', function (event) {
      accessoryStateDirty = false;
      accessoryStateRevision += 1;
      updateAccessoryControlsFromCart(event.detail?.data);
    });

    function hydrateAccessoryControls() {
      if (!window.CartManager || !accessoryControls.length) return;
      window.CartManager.get().then(function (result) {
        if (result?.success && !accessoryStateDirty) {
          updateAccessoryControlsFromCart(result.data);
        }
      });
    }

    hydrateAccessoryControls();

    var selectedOptions = {};

    if (buyBar && buyBarSentinel) {
      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var buyBarHeight = 0;

      function measureBuyBarPosition(restoreFixed) {
        var wasFixed = buyBar.classList.contains('is-fixed');

        if (wasFixed) buyBar.classList.remove('is-fixed');
        buyBarSentinel.style.height = '0px';

        buyBarHeight = buyBar.offsetHeight || 75;

        if (wasFixed && restoreFixed) {
          buyBarSentinel.style.height = buyBarHeight + 'px';
          buyBar.classList.add('is-fixed');
        }
      }

      function updateBuyBarFixedState() {
        if (!desktopQuery.matches) {
          buyBar.classList.remove('is-fixed');
          buyBarSentinel.style.height = '0px';
          return;
        }

        var wasFixed = buyBar.classList.contains('is-fixed');

        if (wasFixed) {
          buyBar.classList.remove('is-fixed');
          buyBarSentinel.style.height = '0px';
        }

        var buyBarRect = buyBar.getBoundingClientRect();
        var shouldFix = buyBarRect.bottom <= 0;

        if (shouldFix) {
          buyBarSentinel.style.height = buyBarHeight + 'px';
          buyBar.classList.add('is-fixed');
        } else {
          buyBar.classList.remove('is-fixed');
          buyBarSentinel.style.height = '0px';
        }
      }

      measureBuyBarPosition(false);
      window.addEventListener('scroll', updateBuyBarFixedState, { passive: true });
      window.addEventListener('resize', function () {
        measureBuyBarPosition(buyBar.classList.contains('is-fixed'));
        updateBuyBarFixedState();
      });

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', function () {
          measureBuyBarPosition(buyBar.classList.contains('is-fixed'));
          updateBuyBarFixedState();
        });
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(function () {
          measureBuyBarPosition(buyBar.classList.contains('is-fixed'));
          updateBuyBarFixedState();
        });
      }

      updateBuyBarFixedState();
    }

    section.querySelectorAll('[data-custom-select]').forEach(function (el) {
      var pos = el.dataset.optionPosition;
      var selected = el.querySelector('[data-select-option][aria-selected="true"]');
      if (!selected) selected = el.querySelector('[data-select-option]');
      if (selected) selectedOptions[pos] = selected.dataset.selectOption;
    });

    section.querySelectorAll('[data-swatch-value]').forEach(function (el) {
      if (el.getAttribute('aria-pressed') === 'true') {
        selectedOptions[el.dataset.optionPosition] = el.dataset.swatchValue;
      }
    });

    function findVariant() {
      var keys = Object.keys(selectedOptions).sort();
      var match = productData.filter(function (variant) {
        return keys.every(function (key) {
          return variant.options[parseInt(key, 10) - 1] === selectedOptions[key];
        });
      });
      return match.find(function (variant) { return variant.available; }) || match[0] || productData[0];
    }

    function formatMoney(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      return 'R$ ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    }

    function updateInstallments(price) {
      if (!installmentEl) return;

      var maxInstallments = parseInt(installmentEl.dataset.maxInstallments || '3', 10);
      var minInstallmentCents = parseInt(installmentEl.dataset.minInstallmentCents || '0', 10);
      var installmentCount = 1;

      if (!maxInstallments || maxInstallments < 1) maxInstallments = 1;
      if (maxInstallments > 12) maxInstallments = 12;

      for (var i = 1; i <= maxInstallments; i++) {
        var installmentValue = Math.floor(price / i);

        if (minInstallmentCents <= 0 || installmentValue >= minInstallmentCents) {
          installmentCount = i;
        }
      }

      installmentEl.textContent = 'em até ' + installmentCount + 'x s/juros';
    }

    function updateVariantUrl(variant) {
      if (!variant || !variant.id || !window.history?.replaceState) return;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({ variantId: variant.id }, '', url.toString());
    }

    function updateUI(variant, shouldUpdateGallery, shouldUpdateUrl) {
      if (!variant) return;
      variantInput.value = variant.id;

      if (shouldUpdateGallery) renderVariantGallery(variant);
      if (shouldUpdateUrl) updateVariantUrl(variant);

      if (skuEl) {
        var sku = variant.sku || '';
        skuEl.textContent = sku ? 'Ref: ' + sku : '';
        skuEl.classList.toggle('hidden', !sku);
        if (skuSeparatorEl) skuSeparatorEl.classList.toggle('hidden', !sku);
      }

      if (priceEl) {
        var cents = variant.price;
        var money = (cents / 100).toFixed(2).replace('.', ',');
        var parts = money.split(',');
        priceEl.innerHTML =
          '<span style="font-family:\'DIN\',sans-serif;font-size:11px;font-weight:500;color:#1A1A1A;line-height:24px">R$ </span>' +
          '<span style="font-family:\'DIN\',sans-serif;font-size:24px;font-weight:500;color:#1A1A1A;line-height:24px">' + parts[0] + ',</span>' +
          '<span style="font-family:\'DIN\',sans-serif;font-size:11px;font-weight:500;color:#1A1A1A;line-height:24px">' + parts[1] + '</span>';
      }

      var compareCents = variant.compare_at_price || 0;
      var hasCompare = compareCents > variant.price;
      var discountPercent = hasCompare ? Math.floor((compareCents - variant.price) * 100 / compareCents) : 0;

      if (comparePriceEl) {
        comparePriceEl.textContent = hasCompare ? formatMoney(compareCents) : '';
        comparePriceEl.classList.toggle('hidden', !hasCompare);
      }

      if (discountBadgeEl) {
        discountBadgeEl.textContent = discountPercent > 0 ? discountPercent + '% OFF' : '';
        discountBadgeEl.classList.toggle('hidden', discountPercent <= 0);
      }

      productTagEls.forEach(function (tagEl) {
        tagEl.classList.toggle('hidden', discountPercent > 0);
        tagEl.classList.toggle('lg:inline-flex', discountPercent > 0);
        tagEl.classList.toggle('inline-flex', discountPercent <= 0);
      });

      updateInstallments(variant.price);

      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? 'Comprar' : 'Esgotado';
      }
    }

    function updateColorTooltipPosition(swatch) {
      swatch.style.setProperty('--pdp-tooltip-offset-x', '0px');

      var swatchRect = swatch.getBoundingClientRect();
      var tooltipStyle = getComputedStyle(swatch, '::after');
      var tooltipWidth = parseFloat(tooltipStyle.width) || 0;

      if (tooltipStyle.boxSizing === 'content-box') {
        tooltipWidth += parseFloat(tooltipStyle.paddingLeft) || 0;
        tooltipWidth += parseFloat(tooltipStyle.paddingRight) || 0;
      }

      var viewportMargin = 8;
      var tooltipCenter = swatchRect.left + (swatchRect.width / 2);
      var tooltipLeft = tooltipCenter - (tooltipWidth / 2);
      var tooltipRight = tooltipCenter + (tooltipWidth / 2);
      var offsetX = 0;

      if (tooltipLeft < viewportMargin) {
        offsetX = viewportMargin - tooltipLeft;
      } else if (tooltipRight > window.innerWidth - viewportMargin) {
        offsetX = (window.innerWidth - viewportMargin) - tooltipRight;
      }

      swatch.style.setProperty('--pdp-tooltip-offset-x', offsetX + 'px');
    }

    section.querySelectorAll('[data-swatch-option][data-color-name]').forEach(function (swatch) {
      swatch.addEventListener('pointerenter', function () {
        updateColorTooltipPosition(swatch);
      });
      swatch.addEventListener('focus', function () {
        updateColorTooltipPosition(swatch);
      });
    });

    section.querySelectorAll('[data-pdp-color-more-toggle]').forEach(function (toggle) {
      if (toggle.dataset.ready === 'true') return;

      var remainingColors = section.querySelectorAll('[data-pdp-color-extra]');
      if (!remainingColors.length) return;

      var collapsedLabel = toggle.dataset.collapsedLabel || toggle.textContent.trim();
      var expandedLabel = toggle.dataset.expandedLabel || 'Ocultar cores';
      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        remainingColors.forEach(function (color) {
          color.hidden = isExpanded;
        });
        toggle.textContent = isExpanded ? collapsedLabel : expandedLabel;
      });

      toggle.dataset.ready = 'true';
    });

    section.querySelectorAll('[data-swatch-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.dataset.optionPosition;
        var val = btn.dataset.swatchValue;
        var optName = btn.dataset.swatchOption;
        selectedOptions[pos] = val;

        var selectedColorValue = section.querySelector('[data-color-selected-value][data-color-position="' + pos + '"]');
        if (selectedColorValue) selectedColorValue.textContent = val;

        section.querySelectorAll('[data-swatch-option="' + optName + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('w-[24px]', 'h-[24px]', 'ring-[1.5px]', 'ring-offset-[2px]', 'ring-[#262626]');
          b.classList.add('w-[18px]', 'h-[18px]');
        });
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.remove('w-[18px]', 'h-[18px]');
        btn.classList.add('w-[24px]', 'h-[24px]', 'ring-[1.5px]', 'ring-offset-[2px]', 'ring-[#262626]');

        updateUI(findVariant(), true, true);
      });
    });

    section.querySelectorAll('[data-select-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var customSelect = trigger.closest('[data-custom-select]');
        var list = customSelect.querySelector('[data-select-list]');
        var isOpen = !list.classList.contains('hidden');
        section.querySelectorAll('[data-select-list]').forEach(function (l) {
          l.classList.add('hidden');
          var closedSelect = l.closest('[data-custom-select]');
          var closedTrigger = closedSelect.querySelector('[data-select-trigger]');
          var closedIcon = closedSelect.querySelector('[data-select-icon]');
          closedTrigger.setAttribute('aria-expanded', 'false');
          if (closedIcon) closedIcon.classList.remove('rotate-180');
        });
        if (!isOpen) {
          list.classList.remove('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        }
        var icon = customSelect.querySelector('[data-select-icon]');
        if (icon) icon.classList.toggle('rotate-180', !isOpen);
      });
    });

    section.querySelectorAll('[data-select-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var customSelect = opt.closest('[data-custom-select]');
        var pos = customSelect.dataset.optionPosition;
        var value = opt.dataset.selectOption;
        var display = customSelect.querySelector('[data-select-display]');
        var list = customSelect.querySelector('[data-select-list]');
        var trigger = customSelect.querySelector('[data-select-trigger]');
        var icon = customSelect.querySelector('[data-select-icon]');
        if (display) display.textContent = value;
        customSelect.querySelectorAll('[data-select-option]').forEach(function (o) {
          o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
        });
        list.classList.add('hidden');
        trigger.setAttribute('aria-expanded', 'false');
        if (icon) icon.classList.remove('rotate-180');
        selectedOptions[pos] = value;
        updateUI(findVariant(), true, true);
      });
    });

    document.addEventListener('click', function () {
      section.querySelectorAll('[data-select-list]').forEach(function (l) {
        l.classList.add('hidden');
        var customSelect = l.closest('[data-custom-select]');
        var trigger = customSelect.querySelector('[data-select-trigger]');
        var icon = customSelect.querySelector('[data-select-icon]');
        trigger.setAttribute('aria-expanded', 'false');
        if (icon) icon.classList.remove('rotate-180');
      });
    });

    var qtyInput   = section.querySelector('[data-qty-input]');
    var qtyDisplay = section.querySelector('[data-qty-display]');
    var qtyMinus   = section.querySelector('[data-qty-minus]');
    var qtyPlus    = section.querySelector('[data-qty-plus]');

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) { v--; qtyInput.value = v; if (qtyDisplay) qtyDisplay.textContent = v; }
      });
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10);
        v++; qtyInput.value = v; if (qtyDisplay) qtyDisplay.textContent = v;
      });
    }

    section.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var body   = trigger.nextElementSibling;
        var icon   = trigger.querySelector('.pdp-accordion-icon');
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (body)  body.classList.toggle('is-open', !isOpen);
        if (icon)  icon.classList.toggle('rotate-180', !isOpen);
      });
    });

    var mobileGallery = document.getElementById('pdp-mobile-gallery-' + sid);
    var mobileDots = section.querySelectorAll('[data-mobile-dot]');
    var mobileGalleryPrev = section.querySelector('[data-pdp-gallery-prev]');
    var mobileGalleryNext = section.querySelector('[data-pdp-gallery-next]');

    function updateMobileGalleryHeight() {
      if (!mobileGallery || !window.matchMedia('(max-width: 1023px)').matches) return;

      var buyBarHeight = buyBar ? buyBar.getBoundingClientRect().height : 75;
      var galleryTopOffset = Math.max(0, mobileGallery.getBoundingClientRect().top);
      section.style.setProperty('--pdp-mobile-buy-bar-height', buyBarHeight + 'px');
      section.style.setProperty('--pdp-mobile-gallery-top-offset', galleryTopOffset + 'px');
    }

    updateMobileGalleryHeight();
    window.addEventListener('resize', updateMobileGalleryHeight);

    function getVisibleMobileGallerySlides() {
      if (!mobileGallery) return [];

      return Array.prototype.filter.call(
        mobileGallery.querySelectorAll('[data-pdp-gallery-slide]'),
        function (slide) {
          return slide.style.display !== 'none';
        }
      );
    }

    function moveMobileGallery(direction) {
      var slides = getVisibleMobileGallerySlides();
      if (!mobileGallery || slides.length < 2) return;

      var currentIndex = Math.round(mobileGallery.scrollLeft / mobileGallery.offsetWidth);
      var targetIndex = (currentIndex + direction + slides.length) % slides.length;
      var targetSlide = slides[targetIndex];

      mobileGallery.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
      });
    }

    if (mobileGalleryPrev && mobileGalleryNext) {
      mobileGalleryPrev.addEventListener('click', function () {
        moveMobileGallery(-1);
      });

      mobileGalleryNext.addEventListener('click', function () {
        moveMobileGallery(1);
      });
    }

    if (mobileGallery && mobileDots.length) {
      var scrollTimer;
      mobileGallery.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(mobileGallery.scrollLeft / mobileGallery.offsetWidth);
          mobileDots.forEach(function (dot, i) {
            dot.classList.toggle('opacity-100', i === idx);
            dot.classList.toggle('opacity-30',  i !== idx);
            dot.classList.toggle('is-active', i === idx);
          });
        }, 50);
      });

      mobileDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.dataset.index, 10);
          mobileGallery.scrollTo({ left: idx * mobileGallery.offsetWidth, behavior: 'smooth' });
        });
      });
    }

    var cepInput   = section.querySelector('[data-cep-input]');
    var cepCalcBtn = section.querySelector('[data-cep-calculate]');
    var cepResults = section.querySelector('[data-shipping-results]');
    var pdpCepShippingHandled = false;

    if (cepInput && cepCalcBtn && cepResults) {
      function pdpShowShippingResults(html) {
        cepResults.classList.remove('hidden');
        cepResults.classList.add('flex');
        cepResults.innerHTML = html;
      }

      function pdpEscapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (character) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
          }[character];
        });
      }

      function pdpFormatDeliveryRange(value) {
        var rawRange = String(value || '').trim();
        if (!rawRange) return '';

        var dateParts = rawRange.split(',').map(function (part) { return part.trim(); }).filter(Boolean);
        var hasOnlyDates = dateParts.length > 0 && dateParts.every(function (part) {
          return /^\d{4}-\d{2}-\d{2}$/.test(part);
        });

        if (hasOnlyDates) {
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          var days = dateParts.map(function (part) {
            var deliveryDate = new Date(part + 'T00:00:00');
            return Math.max(1, Math.ceil((deliveryDate - today) / 86400000));
          });
          var firstDay = Math.min.apply(null, days);
          var lastDay = Math.max.apply(null, days);
          return firstDay === lastDay
            ? 'em até ' + firstDay + ' dias'
            : 'de ' + firstDay + ' a ' + lastDay + ' dias';
        }

        var numericRange = rawRange.match(/(\d+)\s*(?:-|a|até)\s*(\d+)/i);
        if (numericRange) return 'de ' + numericRange[1] + ' a ' + numericRange[2] + ' dias';

        return rawRange;
      }

      function pdpSetShippingLoading(isLoading) {
        var label = cepCalcBtn.querySelector('[data-cep-calculate-label]');
        var loading = cepCalcBtn.querySelector('[data-cep-calculate-loading]');
        cepCalcBtn.disabled = isLoading;
        cepCalcBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (label) label.classList.toggle('hidden', isLoading);
        if (loading) {
          loading.classList.toggle('hidden', !isLoading);
          loading.classList.toggle('inline-block', isLoading);
        }
      }

      function pdpRenderShippingRates(rates) {
        if (!rates.length) {
          pdpShowShippingResults('<p style="font-size:12px;color:#1A1A1A">Nenhuma opção disponível para este CEP.</p>');
          return;
        }

        pdpShowShippingResults(rates.map(function (rate) {
          var price = rate.price || '0';
          var priceNumber = parseFloat(String(price).replace(',', '.'));
          var priceStr = priceNumber === 0 ? 'Grátis' : 'R$ ' + priceNumber.toFixed(2).replace('.', ',');
          var deliveryStr = pdpFormatDeliveryRange(rate.delivery_range);

          return '<div class="pdp-shipping-rate">' +
            '<span class="pdp-shipping-rate__name">' + pdpEscapeHtml(rate.name || 'Frete') + '</span>' +
            '<span class="pdp-shipping-rate__delivery">' + pdpEscapeHtml(deliveryStr) + '</span>' +
            '<span class="pdp-shipping-rate__price">' + pdpEscapeHtml(priceStr) + '</span>' +
            '</div>';
        }).join(''));
      }

      function pdpGetCurrentCartQuantity(cart, variantId) {
        var quantity = 0;

        cart.items.forEach(function (item) {
          if (String(item.variant_id) === String(variantId)) {
            quantity += item.quantity;
          }
        });

        return quantity;
      }

      function pdpChangeCartQuantity(variantId, quantity) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });
      }

      function pdpFetchRatesWithCurrentProduct(params) {
        var variantId = variantInput ? variantInput.value : '';
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

        if (!variantId) throw new Error('Variante não encontrada');
        if (!quantity || quantity < 1) quantity = 1;

        return fetch('/cart.js')
          .then(function (response) {
            if (!response.ok) throw response;
            return response.json();
          })
          .then(function (cart) {
            var originalQuantity = pdpGetCurrentCartQuantity(cart, variantId);

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: quantity })
            })
              .then(function (response) {
                if (!response.ok) throw response;
                return fetch('/cart/shipping_rates.json?' + params.toString());
              })
              .then(function (response) {
                if (!response.ok) throw response;
                return response.json();
              })
              .finally(function () {
                return pdpChangeCartQuantity(variantId, originalQuantity).catch(function () {});
              });
          });
      }

      function pdpCalculateShipping(event) {
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        if (pdpCepShippingHandled) return;
        pdpCepShippingHandled = true;

        var cep = cepInput.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          pdpShowShippingResults('<p style="font-size:12px;color:#d32f2f">Digite um CEP válido com 8 dígitos.</p>');
          pdpCepShippingHandled = false;
          return;
        }

        pdpShowShippingResults('<p style="font-size:12px;color:#1A1A1A">Calculando...</p>');
        pdpSetShippingLoading(true);

        fetch('https://viacep.com.br/ws/' + cep + '/json/')
          .then(function (response) { return response.json(); })
          .then(function (address) {
            if (address.erro) throw new Error('CEP não encontrado');

            var params = new URLSearchParams({
              'shipping_address[zip]': cep,
              'shipping_address[country]': 'BR',
              'shipping_address[province]': address.uf || '',
              'shipping_address[city]': address.localidade || ''
            });

            return pdpFetchRatesWithCurrentProduct(params);
          })
          .then(function (data) {
            pdpRenderShippingRates(data.shipping_rates || []);
          })
          .catch(function () {
            pdpShowShippingResults('<p style="font-size:12px;color:#d32f2f">CEP não encontrado. Verifique e tente novamente.</p>');
          })
          .finally(function () {
            pdpSetShippingLoading(false);
            pdpCepShippingHandled = false;
          });
      }

      cepCalcBtn.addEventListener('click', pdpCalculateShipping, true);
      cepInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') pdpCalculateShipping(event);
      });

      cepInput.addEventListener('input', function () {
        var v = cepInput.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        cepInput.value = v;

        if (v.replace(/\D/g, '').length === 8) pdpCalculateShipping();
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-tutoriais"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountVideoSliders = () => {
      if (typeof Splide === 'undefined') return;

      document.querySelectorAll('[data-video-tutorial-slider]').forEach((slider) => {
        if (slider.dataset.splideMounted === 'true') return;

        const list = slider.querySelector(':scope > .splide__track > .splide__list');
        if (!list) return;

        list.querySelectorAll('[data-video-card]').forEach((card) => {
          let slide = card;

          while (slide.parentElement && slide.parentElement !== list) {
            slide = slide.parentElement;
          }

          if (slide.parentElement === list) {
            slide.classList.add('splide__slide');
          }
        });

        if (!list.querySelector(':scope > .splide__slide')) return;

        slider.dataset.splideMounted = 'true';
        new Splide(slider, {
          type: 'slide',
          perPage: 3,
          perMove: 1,
          gap: '16px',
          trimSpace: true,
          arrows: true,
          pagination: false,
          drag: true,
          breakpoints: {
            1023: {
              perPage: 1,
              gap: '12px',
              trimSpace: true,
            },
          },
        }).mount();
      });
    };

    const activateVideo = (trigger) => {
      const card = trigger.closest('[data-video-card]');
      const player = card?.querySelector('[data-video-player]');
      const media = player?.querySelector('iframe, video');
      if (!card || !player || !media || trigger.hidden) return;

      trigger.hidden = true;
      player.hidden = false;

      const iframe = player.querySelector('iframe');
      if (iframe && iframe.dataset.src) iframe.src = iframe.dataset.src;

      const video = player.querySelector('video');
      if (video) video.play().catch(() => {});
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-video-trigger]');
      if (trigger) activateVideo(trigger);
    });

    const boot = () => {
      if (typeof Splide !== 'undefined') {
        mountVideoSliders();
        return;
      }

      const splideScript = document.querySelector('script[src*="splide.min.js"]');
      if (splideScript) splideScript.addEventListener('load', mountVideoSliders, { once: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', mountVideoSliders);
  })();

  } catch(e) { console.error(e); }
})();
})();
